import {GetPsFeePayInfo} from '@application/PsFee/GetPsFeePayInfo';

export const PsFee = {
  getInfo: GetPsFeePayInfo,
};
